export const SUBMIT_PRODUCT_TR_FORM = 'productTRForm/SUBMIT_PRODUCT_TR_FORM';
// export const LOAD_FORM = 'categoryForm/LOAD_FORM';
